import customerQuery from '~layers/app/graphql/account/customer.gql'

// const customerData = ref<any>()
// const customerDataError = ref<any>()
// const customerDataLoaded = ref<boolean>(false)
// const customerDataLoading = ref<boolean>(false)
// const customerDataPromise = ref<Promise<any> | null>(null)

// const customerDataQuery = async () => {
//   customerDataLoading.value = true
//   const result = await useAsyncQuery({
//     query: customerQuery,
//     clientId: 'customer',
//   })
//   customerData.value = result.data.value
//   customerDataError.value = result.error.value
//   customerDataLoaded.value = true
//   customerDataLoading.value = false
//   if (result.error.value) {
//     const { onLogout } = useApollo()
//     await onLogout('customer')
//   }
// }

export function useAccount() {
  const customerData = useState<any>('customerData', () => undefined)
  const customerDataError = useState<any>('customerDataError', () => undefined)
  const customerDataLoaded = useState<boolean>('customerDataLoaded', () => false)
  const customerDataLoading = useState<boolean>('customerDataLoading', () => false)
  const customerDataPromise = useState<Promise<any> | null>('customerDataPromise', () => null)

  const customerDataQuery = async () => {
    customerDataLoading.value = true
    const result = await useAsyncQuery({
      query: customerQuery,
      clientId: 'customer',
    })
    customerData.value = result.data.value
    customerDataError.value = result.error.value
    customerDataLoaded.value = true
    customerDataLoading.value = false
    if (result.error.value) {
      const { onLogout } = useApollo()
      await onLogout('customer')
    }
  }

  const { getToken } = useApollo()

  const isLoggedIn = computed<boolean>(() => {
    // console.log('isLoggedIn computed', customerData.value)
    return customerData.value !== undefined
  })

  const load = async () => {
    if (await getToken('customer')) {
      if (!customerDataPromise.value) {
        customerDataPromise.value = customerDataQuery()
      }
      await customerDataPromise.value
    }
    else {
      customerDataLoaded.value = true
    }
  }

  const refetch = async () => {
    await customerDataQuery()
  }

  const reset = () => {
    customerData.value = undefined
    customerDataError.value = undefined
    customerDataLoaded.value = false
    customerDataLoading.value = false
    customerDataPromise.value = null
  }

  onMounted(() => load())

  return {
    load,
    refetch,
    reset,
    customerData,
    customerDataLoaded,
    customerDataLoading,
    customerDataError,
    customerDataPromise,
    isLoggedIn,
  }
}
